import React from 'react'
import { IntegrationsOsCommerceSec } from './integrationsOsCommerceSec'

export const IntegrationsOsCommerce = () => {
  return (
    <IntegrationsOsCommerceSec />
  )
}
